import React from 'react';
import {Navigate} from 'react-router-dom';
import {ErrorBoundary} from 'react-error-boundary';

import {PublicTemplate} from 'presentation/templates';
import {HomeEnum, SelectionFlowEnum} from 'presentation/constants';
import {ErrorFallback} from 'presentation/components';
import {getLoginToken, getAccessToken} from 'infra/http/utils';

export const PublicRoutes = () => {
	const loginToken = getLoginToken();
	const accessToken = getAccessToken();

	if (accessToken) {
		return <Navigate to={HomeEnum.HOME_PAGE} replace />;
	}

	if (loginToken) {
		return <Navigate to={SelectionFlowEnum.PLAN_SELECTION} replace />;
	}

	return (
		<ErrorBoundary
			FallbackComponent={({resetErrorBoundary}) => (
				<ErrorFallback resetErrorBoundary={resetErrorBoundary} />
			)}
			onReset={() => window.location.reload()}>
			<PublicTemplate />
		</ErrorBoundary>
	);
};
